import { useEffect } from 'react';

/** Asks the browser to confirm leaving or refreshing while `active` (e.g. mid-save). */
export const useWarnBeforeUnload = (active: boolean): void => {
  useEffect(() => {
    if (!active) return;
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      // Some browsers still require returnValue to be set to show the prompt.
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [active]);
};
